<template>
  <div class="modal-box">
    <div class="modal refund-modal" @click.self="$emit('close-btn-click')">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">払い戻し申請</h4>
            <p>払い戻しを実行します。</p>
          </div>
          <div class="modal-body">
            <div class="sec-fee-burden-eventer">
              <label class="sec-fee-burden-eventer-label">手数料負担者の選択</label>
              <br />
              <div class="sec_fee_burden_eventer_button">
                <input type="radio" name="is_fee_burden_eventer" value="false" checked class="is_fee_burden_eventer" @change="updateFeeBurdenAudience($event.target.value)" />
                <label>主催者</label>
                <input type="radio" name="is_fee_burden_eventer" value="true" @change="updateFeeBurdenAudience($event.target.value)" />
                <label>購入者</label>
              </div>
              <span class="supplement-block">返金手数料の負担者を選択してください。</span>
            </div>
            <label> 件名：【TIGET】返金のお知らせ</label>
            <div class="mail-text-frame">
              <div class="mail-text">
                <div class="refunds-mail-header">{{ audience.name }}様</div>
                <div class="help-text">ここから</div>
                <div>
                  <textarea class="form-control" v-model="r_message" @change="updateRefundMessage($event.target.value)"></textarea>
                </div>
                <div class="help-text">ここまで編集できます</div>
                <div class="refunds-mail-footer">
                  <p>---------------------------------------------</p>
                  <p class="event-title">『{{ main_event_title }}』</p>
                  <p>■開催日：{{ main_event_play_date }}</p>
                  <p class="audience-ticket-info">■チケット情報：{{ audience.start_and_open_times.join('\n') }}</p>
                  <template v-if="event_use_introducer">
                    <template v-for="(eq, index) in event_questionnaires">
                      <p v-if="audience.event_questionnaire_answers.length > index" :key="index">
                        ■{{ eq.introducer_text }}：{{ audience.event_questionnaire_answers[index].introducer }}
                      </p>
                      <p v-else :key="index">
                        ■{{ eq.introducer_text }}：未回答
                      </p>
                    </template>
                  </template>
                  <template v-if="use_introducer_tell">
                    <p>■電話番号：{{ audience.introducer_tell }}</p>
                  </template>
                  <template v-if="use_introducer_adress">
                    <p>■住所：{{ audience.introducer_adress }}</p>
                  </template>
                  <template v-if="use_introducer_name">
                    <p>■氏名：{{ audience.introducer_name }}</p>
                  </template>
                  <template v-if="event_place">
                    <p>■会場：{{ event_place }}</p>
                  </template>
                  <p class="link-word-break">
                    『{{ main_event_title }}』のページはこちら<a class="block-link" :href="event_url">{{ event_url }}</a>
                  </p>
                  <template v-if="contact_info">
                    <p>お問い合わせ：{{ contact_info }}</p>
                  </template>
                  <template v-if="use_contact_form">
                    <p class="link-word-break">
                      フォームからのお問い合わせはこちら <a class="block-link" :href="inquiry_url">{{ inquiry_url }}</a>
                    </p>
                  </template>
                  <template v-else>
                    <p v-if="contact_mails.length > 0">メールでのお問い合わせ：{{ contact_mails }}</p>
                    <p v-if="contact_tels.length > 0">電話でのお問い合わせ：{{ contact_tels }}</p>
                    <p v-if="contact_urls.length > 0">お問い合わせページ：{{ contact_urls }}</p>
                  </template>
                  <p class="purchase-details">ご購入内容</p>
                  <p>■お名前：{{ audience.name }}様</p>
                  <p>■チケット枚数：{{ audience.volume }}枚</p>
                  <template v-if="audience.is_reservation_seat == true">
                    <p>
                      ■座席番号：<template v-for="seat_str in audience.seats_array">{{ seat_str }}</template>
                    </p>
                  </template>
                  <template v-else>
                    <p>■受付番号：{{ audience.receipt_no }}番</p>
                  </template>
                  <p>■購入金額：{{ formatPrice(audience.amount) }}</p>
                  <template v-if="audience.is_refund_fee_audience == true || is_refund_fee_audience == true">
                    <p>※返金手数料{{ audience.purchaser_fee }}円を除いて返金されますのでご了承ください。</p>
                  </template>
                  <p>---------------------------------------------</p>
                  <p>チケット購入・予約プラットフォーム「TIGET(チゲット)」</p>
                  <p>https://tiget.net</p>
                  <p>---------------------------------------------</p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-warning" @click="$emit('close-btn-click')">閉じる</button>
            <button type="button" class="btn btn-primary refund-modal-submit" @click="refundAudience(audience.id, audience.name)">払い戻し実行</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    audience: { type: Object, required: true },
    refund_message: { type: String, required: true },
    main_event_title: { type: String, required: true },
    main_event_play_date: { type: String, required: true },
    event_use_introducer: { type: Boolean, required: true },
    event_introducer_text: { type: String, required: true },
    event_questionnaires: { type: Array, required: true },
    use_introducer_tell: { type: Boolean, required: true },
    use_introducer_name: { type: Boolean, required: true },
    use_introducer_adress: { type: Boolean, required: true },
    event_place: { type: String, required: true },
    event_url: { type: String, required: true },
    contact_info: { type: String, required: true },
    inquiry_url: { type: String, required: true },
    edit_audience_path: { type: String, required: true },
    main_event_id: { type: Number, required: true },
    use_contact_form: { type: Boolean, required: true },
    contact_mails: { type: String, required: true },
    contact_tels: { type: String, required: true },
    contact_urls: { type: String, required: true },
  },
  data() {
    return {
      is_refund_fee_audience: false,
      r_message: '',
    };
  },
  created() {
    if (this.refund_message !== '') {
      this.r_message = this.refund_message;
    } else {
      this.r_message = 'この度「TIGET」にてご購入いただきました下記のイベントの返金手続きをいたしましたので、ご連絡させていただきます。ご請求が発生した同じクレジットカードを通じてご返金となりますので、締め日のタイミングによっては、一度請求が発生いたしますが、その後、返金処理となります。返金日につきましては、各カード会社様によって異なりますため、詳しくはご利用のカード会社様へご確認ください。ご返金までにお時間を頂戴いたしますが、あらかじめご了承ください。';
    }
  },
  methods: {
    updateFeeBurdenAudience(value) {
      if (value === 'true') {
        this.is_refund_fee_audience = true;
      } else {
        this.is_refund_fee_audience = false;
      }
    },
    async refundAudience(id, name) {
      this.$emit('open-loading');
      const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      let is_fee_burden_eventer = document.getElementsByName('is_fee_burden_eventer')[0].checked;
      // 払い戻し処理を行うticket_controller側は文字列で判断しているため文字列に変換する
      let is_fee_burden_eventer_to_s = is_fee_burden_eventer.toString();
      const data = {
        is_fee_burden_eventer: is_fee_burden_eventer_to_s,
        text: this.r_message,
        id: id,
      };
      try {
        await this.$store.dispatch('audience/refundAudience', { refund_audience_path: this.edit_audience_path, data: data, csrf_token: csrfToken, audience_id: id, main_event_id: this.main_event_id })
        // 払い戻しが成功した場合のみ完了通知とモーダルを閉じる
        alert(name + '様への払い戻しが完了しました。')
        this.$emit('close-btn-click')
      } catch (error) {
        // 失敗時はモーダルを開いたままにして再試行できるようにする
        alert('エラーが発生しました。時間をおいてから改めてお試しください。')
      } finally {
        this.$emit('close-loading')
      }
    },
    updateRefundMessage(value) {
      this.r_message = value;
    },
    formatPrice(price) {
      let numericPart = price.replace(/[^\d.-]/g, '');
      return numericPart + '円';
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'app/assets/stylesheets/foundation/variable/color.scss';
$break-point: 768px;

.modal-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $translucent-black;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9998;
}

.refund-modal {
  display: flex;
  overflow-y: auto;

  .modal-title {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .modal-dialog {
    max-width: 100%;
    width: 700px;
    margin: auto;

    @media screen and (max-width: $break-point) {
      margin: auto 30px;
      width: 100%;
      height: 550px;
    }
  }

  .link-word-break {
    word-break: break-all;
  }

  .block-link {
    display: block;
    color: $a-link-color;
  }

  .modal-body {
    padding: 15px;
    line-height: 1.5em;

    .sec-fee-burden-eventer {
      padding-bottom: 15px;
      .sec-fee-burden-eventer-label {
        font-weight: 400;
        margin-bottom: 5px;
      }

      .sec_fee_burden_eventer_button {
        padding: 2px 0;
      }

      .supplement-block {
        font-size: 12px;
        color: $green;
      }
    }

    label {
      font-weight: 500;
    }

    .mail-text-frame {
      padding: 10px 5px;
      overflow-y: scroll;
      border: 1px solid $shop-gray;
      max-height: 400px;

      .refunds-mail-header {
        font-size: 18px;
        margin-bottom: 10px;
        padding-bottom: 2px;
      }

      .help-text {
        font-style: italic;
        color: $help-text-gray;
      }

      .form-control {
        font-size: 14px;
        background-color: $textarea-yellow;
        padding: 6px 12px 6px 0;
        height: 290px;
        box-shadow: none;
      }
    }

    .refunds-mail-footer {
      .event-title,
      .purchase-details {
        font-size: 18px;
        padding-bottom: 2px;
      }

      .audience-ticket-info {
        white-space: pre-line;
      }
    }
  }

  .modal-content {
    box-shadow: none;
    z-index: 9997;
  }

  .modal-footer {
    flex-direction: column;
    margin: auto;

    .btn-close {
      margin-top: 10px;
      border-radius: 4px;
      width: 100%;
      border: 1px solid $shop-lightgray;
      color: $shop-gray;
      margin-left: 0;
    }
  }
}
</style>
